export default __webpack_public_path__ + "static/media/logo.53ea2090.png";